import { UiUtilities } from '@yiluhub/ui-sdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PaymentInputContextProvider } from 'context';

import { PageHeading } from 'components';
import { SummaryLayout } from 'components/Layout';
import { LoadingPageAnimation } from 'components/LoadingPageAnimation';
import { PaymentInformation } from 'components/PaymentInformation';
import ProgressBar from 'components/ProgressBar';

import { ParkingProductSummary } from 'modules/parking/components/ParkingProductSummary';

import { useParkingPaymentInputPage } from './hooks';
import './styles.scss';

const PaymentInputPage: React.FC = () => {
  return (
    <div className="parking-pip">
      <PaymentInputContextProvider>
        <PaymentInputPageInner />
      </PaymentInputContextProvider>
    </div>
  );
};

const PaymentInputPageInner: React.FC = () => {
  const { t } = useTranslation();
  const { isPageReady, paymentInformationFormProps, parkingProductSummaryProps } =
    useParkingPaymentInputPage();

  const isDesktop = UiUtilities.useMediaMatch('--viewport-l');

  if (!isPageReady) {
    return <LoadingPageAnimation />;
  }

  return (
    <div className="form-container-wrapper">
      <div className="form-container container">
        <div className="content">
          <ProgressBar />
          {parkingProductSummaryProps && !isDesktop && (
            <ParkingProductSummary {...parkingProductSummaryProps} />
          )}
          <PageHeading text={t('Header - Payment')} />
          {paymentInformationFormProps && <PaymentInformation {...paymentInformationFormProps} />}
        </div>
        {parkingProductSummaryProps && isDesktop && (
          <SummaryLayout>
            <ParkingProductSummary {...parkingProductSummaryProps} />
          </SummaryLayout>
        )}
      </div>
    </div>
  );
};

export default PaymentInputPage;
